


































































































import {Component, Prop, Vue} from "vue-property-decorator";
import PageLoader from "@/components/common/PageLoader.vue";
import CommunityCard from "@/components/community/_communityCard.vue";

import {AxiosError, AxiosResponse} from "axios";
import {scrollDone} from "@/script/scrollManager";
import {mapGetters} from "vuex";
import SubscribeBtn from "@/components/community/_subscribeBtn.vue";
import UniCons from '@iconscout/vue-unicons'
import ClickManager from "@/script/clickManager";
import MetaSetting from "@/script/metaSetting";

@Component({
    components: {PageLoader, CommunityCard, SubscribeBtn, UniCons},
    computed: {...mapGetters(["user"])},
})
export default class CommunityList extends Vue {
    metaSetting !: MetaSetting;
    clickManager: ClickManager = new ClickManager();
    private communityList: any = [];
    private searchInput: string = "";
    private filter: number = 0;
    private isSearched: boolean = false;

    //fetch data object
    limit: number = 20;
    offset: number = 0;
    community: string = '';
    sort: string = '';
    show: string = ''
    isAddData: boolean = false;
    unCommunityId: string = ''
    user !: any;

    isFirstLoading: boolean = true;

    mounted() {
        this.fetch();
        window.addEventListener("scroll", this.scrollCheck);
    }

    beforeDestroy() {
        window.removeEventListener("scroll", this.scrollCheck);
    }

    fetch() {
        const obj = {
            limit: this.limit,
            offset: this.offset,
            community: this.searchInput,
            sort: this.sort,
            show: this.show
        }

        this.$api.communityList(obj)
            .then((res: any) => {
                if (this.isAddData) {
                    if (res.length > 0) {
                        this.communityList = [...this.communityList, ...res]
                    }
                    else {
                        window.removeEventListener("scroll", this.scrollCheck);
                    }
                }
                else {
                    this.communityList = res;
                    this.isAddData = true
                }
            })
            .catch((err: AxiosError) => {
                console.log(err)
            })
            .finally(() => {
                this.isFirstLoading = false;
                this.createMetaSetting();
            })
    }

    scrollCheck() {
        if (scrollDone(document.documentElement)) {
            this.offset += this.limit;
            this.fetch();
        }
    }

    createMetaSetting(){
        this.metaSetting = new MetaSetting({
            title: `${this.$t('communityList')} | Zempie.com`, //커뮤니티 리스트
            meta: [
                {name: 'description', content: `${this.$t('communityList.desc')}`},
                {property: 'og:url', content: `${this.$store.getters.homeUrl}/${this.$i18n.locale}/communityList`},
                {property: 'og:title', content: `${this.$t('communityList')} | Zempie.com`},
                {property: 'og:description', content: `${this.$t('communityList.desc')}`},
            ]
        });
    }

    unsubscribe(communityId: string) {
        this.$modal.show('deleteConfirm')
        this.unCommunityId = communityId;
    }

    yesUnsubscribe() {
        this.initData()
        this.$api.unsubscribe({user_id: this.user.id, community_id: this.unCommunityId})
            .then((res: any) => {
                this.fetch();
            })
            .catch((err: any) => {
                if (err.message) {
                    alert(err.message)
                }
            })
            .finally(() => {
                this.$modal.hide('deleteConfirm')
            })
    }

    sortGroups(filter: number) {
        this.isAddData = false;
        this.filter = filter;
        if (this.clickManager.doubleClickCheck() === false) {
            if (filter === 0) {
                this.sort = '';
                this.fetch()
            }
            else if (filter === 1) {
                this.sort = 'SUBSCRIBE'
                this.fetch()
            }
            else if (filter === 2) {
                this.sort = 'ALPAHBETIC'
                this.fetch()
            }
        }
    }

    searchCommunity(e: Event) {
        e.preventDefault();
        this.isSearched = true;
        this.isAddData = false;
        this.fetch()
    }

    searchReset(e: Event) {
        e.preventDefault();
        this.initData();
        this.fetch()

    }

    initData() {
        this.isSearched = false;
        this.isAddData = false
        this.limit = 20;
        this.offset = 0;
        this.community = '';
        this.sort = '';
        this.show = '';
        this.searchInput = '';
    }

    reFetch() {
        this.initData();
        this.fetch();
    }
}
